var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUnlabel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2895 5H4C3.44772 5 3 5.44772 3 6V18C3 18.1768 3.04586 18.3428 3.12634 18.4869L4.5 16.2174V6.5H10.3816L11.2895 5ZM10.7237 17.5H15.4072L19.1809 12L16.4562 8.02886L17.3088 6.6202L20.6118 11.4342C20.8457 11.7752 20.8457 12.2248 20.6118 12.5658L16.4951 18.5658C16.3086 18.8376 16.0002 19 15.6706 19H9.81579L10.7237 17.5Z",
    fill: "#7177A8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1875 3.53568C14.381 3.20397 14.7361 3 15.1202 3V3C15.9535 3 16.4727 3.90396 16.0528 4.62376L6.81248 20.4643C6.61898 20.796 6.26386 21 5.87984 21V21C5.04652 21 4.52731 20.096 4.9472 19.3762L14.1875 3.53568Z",
    fill: "#7177A8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnlabel);
export default __webpack_public_path__ + "static/media/icon_unlabel.856f0d4bf709521bdd6e0ca9a7b60eca.svg";
export { ForwardRef as ReactComponent };